export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const gaId = config.public.googleAnalyticsId as string | undefined;

  if (!gaId) {
    return;
  }

  if (import.meta.client) {
    const w = window as any;
    w.dataLayer = w.dataLayer || [];
    w.gtag = w.gtag || function() {
      w.dataLayer.push(arguments);
    };
    w.ga_id = gaId;
    w.ga_initialized = false;

    let defaultConsent = {
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      analytics_storage: "denied",
    };

    try {
      const stored = localStorage.getItem("ga_consent_settings");
      if (stored) {
        defaultConsent = Object.assign({}, defaultConsent, JSON.parse(stored));
      }
    } catch (e) {
      console.error("Error reading GA consent from localStorage:", e);
    }

    w.gtag("consent", "default", defaultConsent);
    w.gtag("js", new Date());
    w.gtag("config", gaId);

    useHead({
      script: [
        {
          src: `https://www.googletagmanager.com/gtag/js?id=${gaId}`,
          async: true,
        },
      ],
    });
  }
});

